import dayjs from 'dayjs';

import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {datetimeObjToISOString} from '../../../../../utils/datetime';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, course, program} = contexts;

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    title: i18n.t('notifications:course_stopped_restarting.title', {
      coachName: actor?.name,
      courseTitle: program?.title,
      endDate: dayjs(datetimeObjToISOString(course?.end_date)).format('ll'),
    }),
  };
};
